import React from 'react'
import { graphql } from 'gatsby'
import Seo from 'components/Seo'
import SeminarLayout from 'components/seminar/SeminarLayout'
import SeminarFv from 'components/seminar/SeminarFv'
import SeminarApplying from 'components/seminar/SeminarApplying'
import SeminarPast from 'components/seminar/SeminarPast'
import AimBlogPagination from 'components/aimBlog/AimBlogPagination'

const SeminarTop = ({ data, pageContext }) => {
  const seminars = pageContext.posts
  return (
    <SeminarLayout>
      <SeminarFv />
      <div className="u-container">
        {pageContext.currentPage === 1 ? <SeminarApplying data={seminars} buildTime={data?.siteBuildMetadata?.buildTime} /> : ''}
        <SeminarPast data={seminars} />
      </div>
      {pageContext.last !== 1 ? <AimBlogPagination baseUrl="/aim/seminar" current={pageContext?.currentPage} last={pageContext?.last} /> : ''}
    </SeminarLayout>
  )
}

export default SeminarTop

export const query = graphql`
  query {
    siteBuildMetadata {
      buildTime
    }
  }
`

export const Head = () => <Seo pagetitle="セミナー情報" description="株式会社メイツでは、学習塾向けの無料セミナーを定期的に開催しています。" />
